import * as React from 'react';

function SvgPictureSplit(props) {
  return (
    <svg width={42} height={42} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.75 35.438a1.313 1.313 0 01-1.313 1.312H5.25a2.626 2.626 0 01-2.2-1.194l8.763-8.762 3.896 3.896-3.435 3.435h2.164a1.313 1.313 0 011.312 1.313zm-3.938-22.313a1.313 1.313 0 100 2.626 1.313 1.313 0 000-2.626zM22.159 24.24l-4.594 4.594-3.896-3.896a2.625 2.625 0 00-3.712 0l-7.331 7.331V7.875A2.628 2.628 0 015.25 5.25h17.063a1.312 1.312 0 011.23 1.774l-3.748 9.989 2.629 5.755a1.313 1.313 0 01-.266 1.472zm-6.408-9.802a3.937 3.937 0 10-7.875 0 3.937 3.937 0 007.875 0zm21-6.563h-9.188a1.313 1.313 0 00-1.218.825l-2.625 6.563a1.313 1.313 0 00.07 1.12l3.691 6.7.81-.811a2.625 2.625 0 013.712 0l7.373 7.372V10.5a2.628 2.628 0 00-2.625-2.625zM23.552 30.721l-4.915 6.554a1.313 1.313 0 001.05 2.1H36.75a2.628 2.628 0 002.625-2.625v-3.394l-9.229-9.229-6.594 6.594z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPictureSplit;
